import { useMutation } from '@apollo/client';

import RemoveFieldVerificationMutation from '@/graphql/contracts/removeFieldVerification.mutation.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  RemoveFieldVerification,
  RemoveFieldVerificationVariables
} from '@/graphql/contracts/_generated_/removeFieldVerification.mutation';
import { notificationService } from '@/services/notification/notification.client';

export type RemoveFieldVerificationDto = RemoveFieldVerificationVariables;

export function useRemoveFieldVerification() {

  const [_removeFieldVerification, { loading }] = useMutation<
  RemoveFieldVerification, RemoveFieldVerificationVariables
  >(RemoveFieldVerificationMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    }
  );

  const removeFieldVerification = (dto: RemoveFieldVerificationDto, onSuccess?: () => void) => {
    _removeFieldVerification({
      variables: dto,
      refetchQueries: ['GetPaginatedFieldVerifications'],
      onCompleted: () => {
        notificationService.open({
          title: 'Field Verification',
          text: 'Verification marked as removed',
          type: 'success',
        });

        onSuccess?.();
      },
    });
  };

  return {
    removeFieldVerification,
    isLoading: loading,
  } as const;
}
